import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.baseBlue.a10};
`;

export const TextRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
`;

export const SubTitle = styled.h4`
  font-size: 21px;
  letter-spacing: 0.3px;
  font-weight: 400;
  margin: 0;
`;

export const LinksRow = styled.div`
  color: ${({ theme }) => theme.black.a5};
`;

export const Anchor = styled.a`
  color: ${({ theme }) => theme.black.a5};
  text-decoration: underline;
  margin-left: 3px;
`;
